// src/components/dashboard/wall/day6/components/winnerComponent.jsx
import { motion, useReducedMotion } from "framer-motion";

const ASSETS = {
  spinner: "/penalty/winner-spinner.svg",
  winnerText: "/penalty/winner-text.svg",
  ironbears: "/penalty/winner-ironbears.svg",
  alphawolves: "/penalty/winner-alphawolves.svg",
  bullmasters: "/penalty/winner-bullmasters.svg",
  goldeneagles: "/penalty/winner-goldeneagles.svg",
};

export default function WinnerComponent({ teamKey = "alphawolves" }) {
  const prefersReducedMotion = useReducedMotion();

  const FADE_IN_DURATION = 1.4;
  const STAGGER = 0.25;
  const SPINNER_SCALE_DELAY = FADE_IN_DURATION + STAGGER;
  const SPINNER_SCALE_DURATION = 0.8;
  const SPIN_DURATION = 50;

  const PULSE_DELAY = SPINNER_SCALE_DELAY + SPINNER_SCALE_DURATION * 0.9;
  const PULSE_DURATION = 2.6;
  const PULSE_KEYFRAMES = prefersReducedMotion ? 1 : [1, 0.9, 1];

  const teamLogoSrc = ASSETS[teamKey] ?? ASSETS.alphawolves;

  return (
    <div className="w-full h-full items-center justify-center flex relative">
      <motion.div
        initial={{ scale: 1 }}
        animate={{
          rotate: prefersReducedMotion ? 0 : 360,
          scale: PULSE_KEYFRAMES,
        }}
        transition={{
          rotate: prefersReducedMotion
            ? { duration: 0 }
            : {
                delay: SPINNER_SCALE_DELAY + SPINNER_SCALE_DURATION * 0.8,
                repeat: Infinity,
                repeatType: "loop",
                ease: "linear",
                duration: SPIN_DURATION,
              },
          scale: prefersReducedMotion
            ? { duration: 0 }
            : {
                delay: PULSE_DELAY,
                duration: PULSE_DURATION,
                repeat: Infinity,
                repeatType: "mirror",
                ease: "easeInOut",
              },
        }}
        className="select-none rounded-[50%]"
        aria-hidden
      >
        <motion.img
          src={ASSETS.spinner}
          alt=""
          initial={{ opacity: 0, scale: 0.6 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{
            opacity: {
              delay: SPINNER_SCALE_DELAY,
              duration: SPINNER_SCALE_DURATION,
              ease: "easeOut",
            },
            scale: {
              delay: SPINNER_SCALE_DELAY,
              duration: SPINNER_SCALE_DURATION,
              ease: "easeOut",
            },
          }}
          className="rounded-[50%]"
        />
      </motion.div>

      {/* use teamLogoSrc based on prop */}
      <motion.img
        src={teamLogoSrc}
        alt={`${teamKey} logo`}
        className="absolute z-20 mb-[84px] select-none"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: FADE_IN_DURATION, ease: "easeOut" }}
      />

      <motion.img
        src={ASSETS.winnerText}
        alt="Winner"
        className="absolute bottom-[33%] select-none -translate-y-1/2 -translate-x-1/2"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          delay: 0.25,
          duration: FADE_IN_DURATION,
          ease: "easeOut",
        }}
      />
    </div>
  );
}
